import { render, staticRenderFns } from "./StatusButton.vue?vue&type=template&id=585ed6b1&scoped=true"
import script from "./StatusButton.vue?vue&type=script&lang=js"
export * from "./StatusButton.vue?vue&type=script&lang=js"
import style0 from "./StatusButton.vue?vue&type=style&index=0&id=585ed6b1&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585ed6b1",
  null
  
)

export default component.exports